import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { runInAction } from 'mobx';
import { DocumentVersionAPI } from './API';
import env from '../misc/env';
import DocumentVersion from './DocumentVersion';
import { getFeatureToggleClient } from '../misc/featureToggles';
import { isVerifyClientDataToggleEnabled } from './toggles/verifyClientDataToggle';
var DocumentVersionStore = /*#__PURE__*/function (_Store) {
  function DocumentVersionStore() {
    var _this;
    _classCallCheck(this, DocumentVersionStore);
    _this = _callSuper(this, DocumentVersionStore, arguments);
    _this.versions = _this.collection({
      model: DocumentVersion
    });
    _this.api = new DocumentVersionAPI({
      baseURL: env.DOCUMENT_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.rootStore.authStore.onLogin(function () {
      var clientDataVerificationEnabled = isVerifyClientDataToggleEnabled();
      _this.api.subscribe('VersionScanned', function (version) {
        if (clientDataVerificationEnabled) {
          var _version$files$;
          var state = (_version$files$ = version.files[0]) === null || _version$files$ === void 0 ? void 0 : _version$files$.state;
          var currentUser = _this.rootStore.authStore.user;
          if (version.author_public_id === currentUser.userPublicId || ['Downloadable', 'Purged', 'Failed'].includes(state)) {
            return _this.versions.set(version);
          }
        }
        return _this.versions.set(version);
      });
      if (clientDataVerificationEnabled) {
        _this.api.subscribe('ClientDataVerified', _this.versions.set);
      }
    });
    return _this;
  }
  _inherits(DocumentVersionStore, _Store);
  return _createClass(DocumentVersionStore, [{
    key: "createVersion",
    value: function () {
      var _createVersion = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var _this2 = this;
        var intDiv, formatSize, document, NEW_DOCUMENT_UPLOAD_ROUTE, documentUploadData, fileDescriptors, _result, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formatSize = function _formatSize(size) {
                // We really only need the first 4 or so, but doesn't hurt to add the rest
                var sizeSuffixes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                var s = size;
                var n = intDiv(s, 1024);
                var i = 0;
                while (n > 0) {
                  s = n;
                  n = intDiv(n, 1024);
                  i += 1;
                }
                return "".concat(s).concat(sizeSuffixes[i]);
              };
              intDiv = function _intDiv(a, b) {
                var result = a / b;
                if (result >= 0) {
                  return Math.floor(result);
                } else {
                  return Math.ceil(result);
                }
              };
              document = this.rootStore.documentStore.documents.get(data.document_id);
              if (data.action === 'ReplaceContents') {
                data.action.files.forEach(function (f) {
                  if (f.size > 500 * 1024 * 1024) {
                    document.set({
                      uploadProgress: null
                    });
                    throw new Error("File \"".concat(f.name, "\" is too large at ").concat(formatSize(f.size), ". Maximum file size is 500MB."));
                  }
                });
              }
              NEW_DOCUMENT_UPLOAD_ROUTE = getFeatureToggleClient().variation('new-document-upload-route', false);
              _context.prev = 5;
              if (!NEW_DOCUMENT_UPLOAD_ROUTE) {
                _context.next = 17;
                break;
              }
              _context.next = 9;
              return this.api.getUploadUrl({
                document_id: data.document_id,
                file_names: data.action.files.map(function (f) {
                  return f.name;
                })
              });
            case 9:
              documentUploadData = _context.sent;
              _context.next = 12;
              return this.api.uploadFromURL(documentUploadData, data.action.files);
            case 12:
              fileDescriptors = documentUploadData.map(function (d, i) {
                return {
                  key: d.key,
                  file_name: data.action.files[i].name
                };
              });
              _context.next = 15;
              return this.api.createFromUrl({
                document_id: data.document_id,
                message: data.message,
                files: fileDescriptors
              }, {
                onProgress: function onProgress(e) {
                  document.set({
                    uploadProgress: {
                      total: e.total,
                      uploaded: e.loaded,
                      percent: Math.ceil(e.loaded / e.total * 100)
                    }
                  });
                }
              });
            case 15:
              _result = _context.sent;
              return _context.abrupt("return", runInAction(function () {
                document.set({
                  uploadProgress: null
                });
                return _this2.versions.set(_result);
              }));
            case 17:
              _context.next = 19;
              return this.api.create(data, {
                onProgress: function onProgress(e) {
                  document.set({
                    uploadProgress: {
                      total: e.total,
                      uploaded: e.loaded,
                      percent: Math.ceil(e.loaded / e.total * 100)
                    }
                  });
                }
              });
            case 19:
              result = _context.sent;
              return _context.abrupt("return", runInAction(function () {
                document.set({
                  uploadProgress: null
                });
                return _this2.versions.set(result);
              }));
            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](5);
              document.set({
                uploadProgress: null
              });
              throw _context.t0 || new Error('There was an error while uploading the document, please try again later');
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 23]]);
      }));
      function createVersion(_x) {
        return _createVersion.apply(this, arguments);
      }
      return createVersion;
    }()
  }]);
}(Store);
export { DocumentVersionStore as default };
//# sourceMappingURL=DocumentVersionStore.js.map
